<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createWorkflow">
              <div class="col-md-5">
                <h5>Trigger</h5>
                <br>
                <form-text label="If" name="if" v-model="trigger.if" validation="required"></form-text>
                <form-text label="Then" name="then" v-model="trigger.then" validation="required"></form-text>
              </div>
              <br>
              <div class="col-md-5">
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createtrigger',
  components:{
    'form-text':FormText
  },
  data () {
    return {
      trigger: {
        if: '',
        then: ''
      }
    }
  },
  methods: {
    createWorkflow:function(){

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateTrigger.vue?3a56759a